import React, { useState, useEffect } from 'react';
import { Spin, Button, Input, Form, Select, DatePicker, Modal, Upload } from 'antd';
import { Navigate, Link } from "react-router-dom";
import { UploadOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
// import axios from 'axios';
import uuid from 'react-uuid';
import NoticeService from '../../../services/NoticeService';

import moment from 'moment';
// import Discussions from '../../lesson/Discussions';
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
import ResponsiveBreadcrumb from '../../breadcrumb/ResponsiveBreadcrumb';
import '../NoticeBoard.css';
// import NoticeBoardList from '../NoticeBoardList';

const { RangePicker } = DatePicker;


function CreateNotice(props) {
   const [title, setTitle] = useState("")
   const [educlevel, setEducLevel] = useState()
   const [gradelevel, setGradeLevel] = useState()
   const [section, setSection] = useState()
   const [sectionList, setSectionList] = useState()
   const [levelList, setLevelList] = useState()
   const [content, setContent] = useState("")
   const [disablesection, setDisableSection] = useState(false)
   const [disablelevel, setDisableLevel] = useState(false)
   const [done, setDone] = useState(false)
   const [effectivityDate, setEffectivityDate] = useState();
   const [fileList, setFileList] = useState([]);
   const [spinning, setSpinning] = useState(false)
   const { TextArea } = Input;
   const [form] = Form.useForm();
   //  const dispatch = useDispatch();
   const lookupSelector = useSelector(state => state.lookup);

   const dateFormat = 'MMM D, YYYY h:mm a';
   const customFormat = value => `${value.format(dateFormat)}`;

   useEffect(() => {
      let urllink = `${process.env.REACT_APP_API_LESSON_LOOKUP}`
      console.log(urllink)
   }, []
   );

const propsUpload = {
    onRemove: file => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: file => {
            const isPNG = file.type === 'image/png';
            const isJPG = file.type === 'image/jpeg';
            const isBMP = file.type === 'image/bmp';
            const isMovie = file.type === 'video/mp4';
            // const isDOC = file.type === 'application/msword' || file.type === 'application/vnd.ms-word';
            // const isDOCX = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            // const isXLS = file.type === 'application/msexcel' || file.type === 'application/vnd.ms-excel';
            // const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            // const isPPT = file.type === 'application/vnd.ms-powerpoint';
            // const isPPTX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            // const isPPSX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.slideshow';
            const isPDF = file.type === 'application/pdf';

            // const fileValid = isPNG || isJPG || isBMP || isDOC || isDOCX || isXLS || isXLSX || isPPT || isPPTX || isPDF || isPPSX;
            const fileValid = isPNG || isJPG || isBMP || isPDF || isMovie;
            if (fileValid) {
               const isLt100M = file.size / 1024 / 1024 <= 10;

               if (isLt100M) {
                  setFileList([...fileList, file]);
               } else {
                  Modal.error({
                     title: 'Schedule',
                     content: 'Maximum allowed file size is 10 MB',
                     centered: true
                  });
               }
            } else {
               Modal.error({
                  title: 'Schedule',
                  content: 'You are not allowed to upload that file type',
                  centered: true
               });
            }      
      return false;
    },
    fileList,
    multiple: true, // Enable multiple file selection
  };

   const FormatDate = () => {
      if (effectivityDate && effectivityDate.length > 0) {
         const d1 = effectivityDate[0];
         const d2 = effectivityDate[1];
         const arr = [moment(d1, dateFormat), moment(d2, dateFormat)];
         return arr;
      } else {
         console.log('no value');
         return [];
      }
   }

   const handleChangeDate = (date, dateString) => {
      const d = dateString[0];//'Jan 21, 2022, 7:07:00 am';
      const d2 = dateString[1];//'Jan 21, 2022, 7:07:00 am';
      const dvalue = d + ' - ' + d2;
      setEffectivityDate(dateString);
   }

   const handleFormValuesChange = (changedValues) => {
      const formFieldName = Object.keys(changedValues)[0];
      if (formFieldName === "educationallevel") {
         setEducLevel(changedValues[formFieldName]);
         form.setFieldsValue({ level: undefined });
         form.setFieldsValue({ sections: undefined });
         setSectionList([])
      } else if (formFieldName === "level") {
         setGradeLevel(changedValues[formFieldName]);
         form.setFieldsValue({ sections: undefined });
         setSectionList([])
      }
   };

   const handleChangeTitle = (e) => {
      setTitle(e)
   }


   const handleChangeEducLevel = (e) => {
      // console.log('Educ Change')
      setEducLevel(e)
      // console.log(`value = ${e}`)
      let templevels = lookupSelector.acadProgramLevels;
      let filtered = templevels.filter(item => item.programCode === `${e}`);
      setLevelList(filtered)
      if (e == '99') {
         // console.log('disable')
         setDisableLevel(true)
         setDisableSection(true)
      } else {
         // console.log('not disable')
         setDisableLevel(false)
         setDisableSection(false)
      }
   }

   const handleChangeLevel = (e) => {
      console.log('handleChangeLevel')
      console.log(e)
      let tempsections = lookupSelector.classSections;
      let filtered = tempsections.filter(item => item.code === `${e}`);
      setGradeLevel(e)
      setSectionList(filtered)
      if (e == '99') {
         setDisableSection(true)
      } else {
         setDisableSection(false)
      }
   }

   const handleChangeSection = (e) => {
      setSection(e);
   }

   const handleChangeEditor = (content, editor) => {
      setContent(content);
   }

    const option = {
    onUploadProgress: (progressEvent) => {
       const { loaded, total } = progressEvent;
       let p = Math.floor((loaded * 100) / total)
      //  setPercentage(p)
       console.log(`${p} %`)
    }
 }

   const onFinish = (values) => {
      // console.log('Success:', values);
      setSpinning(true)
      let user = Utils.getCurrentUserInfo(Enums.UserInfo.id)
      var o2o_mode = Utils.determineOnlineOffline(); //window.location.hostname.match(/localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/gi) ? "offline" : "online";
      var notice_id = "notice_" + o2o_mode + "_" + uuid();
      let gradeLevel = gradelevel;
      let sections = section;
      let educLevel = educlevel;
      let effective_start_date = effectivityDate[0];
      let effective_end_date = effectivityDate[1];

      if (typeof educLevel === 'undefined') {
         educLevel = "";
         console.log('is undefined');
      }

      if (typeof gradeLevel === 'undefined') {
         gradeLevel = "";
         console.log('is undefined');
      }

      if (typeof sections === 'undefined') {
         sections = "";
         console.log('is undefined');
      }


       var FilterfileNewList = fileList.filter(item => item);
      let notice_default = {
         id: notice_id,
         title: title,
         content: content,
         active: 0,
         issection: 0,
         sectionlist: sections,
         isgradelevel: 0,
         gradelevellist: gradeLevel,
         isacad: 0,
         acadlevellist: educLevel,
         staffid: user,
         start_date: effective_start_date,
         end_date: effective_end_date,
         files : FilterfileNewList
      }
      console.log(notice_default);

      NoticeService.saveNotice(notice_default, option).then(response => {
         console.log(response);
         setSpinning(false)
         if (response.data != "Nok") {
            Modal.success({
               title: 'Create Notice Board',
               content: 'Notice Record was created.',
               centered: true
            })

            setDone(true);
         }
         else
         {
            setSpinning(false)
            Modal.error({
               title: 'Create Notice Board',
               content: 'Notice Record creation failed.',
               centered: true
            });            
         }
      }, (error) => {
         console.log(error.message);
         setSpinning(false)
         Modal.error({
            title: 'Create Notice Board',
            content: 'Notice Record creation failed.',
            centered: true
         });
         setDone(false)
      });

   };

   return (
      <>
         {done && <Navigate to={'/notice'} replace state={{}} />}
         <div className="dashboard-area-all noticeboard-page">
            <div className="dashboard-item noticeboard-shell">
               <div className="noticeboard-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'notice-board', node: <Link to="/notice">Notice Board</Link> },
                        { key: 'create', node: 'Create' },
                     ]}
                  />
               </div>
               <section className="noticeboard-overview">
                  <div>
                     <span className="noticeboard-kicker">Announcements</span>
                     <h1>Create Notice</h1>
                     <p>Prepare a new notice, choose the target audience, add content, and attach supporting files.</p>
                  </div>
               </section>
               <Spin spinning={spinning} fullscreen tip="Saving...">
                  <section className="noticeboard-panel">
                     <div className="noticeboard-panel-header">
                        <div>
                           <span className="noticeboard-kicker">Details</span>
                           <h2>Notice Information</h2>
                        </div>
                     </div>
                     <Form
                        form={form}
                        className='noticeboard-form'
                        colon={false}
                        onFinish={onFinish}
                        onValuesChange={handleFormValuesChange}
                        autoComplete="off"
                        layout="vertical"
                     >
                        <div className="noticeboard-form-grid">
                              <Form.Item label="Title" name="title"
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Title should not be blank!'
                                    },
                                 ]} >
                                 <Input
                                    size="small"
                                    placeholder="Title"
                                    value={title}
                                    style={{ color: '#000000' }}
                                       onChange={(event) => handleChangeTitle(event.target.value)}
                                   />

                              </Form.Item>
                              <Form.Item label="Educational Level" name="educationallevel"
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Please choose an Educational Level!'
                                    },
                                 ]} initialValue={''}
                              >
                                 <Select defaultValue={''} onChange={handleChangeEducLevel}>
                                    <Select.Option value={'99'}>{'All'}</Select.Option>
                                    {lookupSelector.acadPrograms.map((level) => (
                                       <Select.Option value={level.programCode}>{level.description}</Select.Option>
                                    ))}
                                 </Select>
                              </Form.Item>

                              <Form.Item label="Grade Level" name="level"
                              rules={[
                              { 
                              required: educlevel == "99" ? false : true,
                              message: 'Please choose a Level!'
                              },
                              ]} initialValue={''}
                              >

                                 <Select
                                    // style={{  width: '40%' }} 
                                    value={gradelevel}
                                    onChange={(e) => {
                                       handleChangeLevel(e);
                                    }}
                                    disabled={disablelevel}
                                 >
                                    <Select.Option value={99}>{'All'}</Select.Option>
                                    {
                                       lookupSelector.acadProgramLevels.filter(item => item.programCode === `${educlevel}`).map((filtered) => (
                                          <Select.Option value={filtered.value}>{filtered.label}</Select.Option>
                                       ))}
                                    {/* { levelList.map((level) => (
                                    <Select.Option value={level.value}>{level.label}</Select.Option>
                                    ))}   */}
                                 </Select>

                                 {/* <Select
                                    placeholder="Please select"
                                    mode="multiple"
                                    allowClear
                                    showArrow
                                    style={{ width: '100%' }}
                                    options={levelList}
                                    onChange={(e) => {
                                       handleChangeLevel(e);
                                       }}
                                    /> */}
                                 {/* <Checkbox>All</Checkbox> */}

                              </Form.Item>
                              <Form.Item label="Sections (Multiple)" name="sections"

                              rules={[
                              { 
                              required: false,
                              message: 'Please choose a Section!'
                              },
                              ]}
                              initialValue={ '' }
                              >
                                 <Select
                                    placeholder="Please select"
                                    mode="multiple"
                                    allowClear
                                    showArrow
                                    style={{ width: '100%' }}
                                    options={sectionList}
                                    onChange={handleChangeSection}
                                    disabled={disablesection}
                                 />

                              </Form.Item>
                              <Form.Item className="noticeboard-form-full" label="Effectivity Date" name="effectivedate"
                               rules={[
                                    {
                                       required: true,
                                       message: 'Please choose Effectivity Date!'
                                    },
                                 ]}
                              >
                                 <RangePicker
                                    showTime={{ format: 'hh:mm A', use12Hours: true }}
                                    format={customFormat}
                                    defaultValue={FormatDate}
                                    onCalendarChange={handleChangeDate}
                                    style={{ width: '100%' }}
                                 />
                              </Form.Item>

                              <Form.Item className="noticeboard-form-full" label="Content" name="content">
                                 <TextArea rows={8} onChange={(e) => handleChangeEditor(e.target.value)} />
                              </Form.Item>
                              <Form.Item className="noticeboard-form-full" label="Add file(s) to the message" name="fileupload">
                                 <div className="noticeboard-upload-wrap">
                                 <Upload {...propsUpload}>
                                    <Button icon={<UploadOutlined />}>Select File</Button>
                                 </Upload>  
                                 </div>
                               </Form.Item>    
                        </div>
                        <div className="noticeboard-form-actions">
                           <Button className="noticeboard-save-button" type="primary" htmlType="submit" shape='round'>
                              Save Notice
                           </Button>
                        </div>
                     </Form>
                  </section>
                  </Spin>
            </div>
         </div>
         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}
      </>
   );
}

export default CreateNotice;
